<div class="edit-time-container">
  <div
    class="lock-icon"
    *ngIf="editLocked"
    inlineSVG="../../assets/icons/lock-black.svg"
  ></div>
  <div class="time-display-locked" *ngIf="editLocked">{{ time }}</div>
  <!-- Add on click once P2 is implemented -->
  <div class="time-display" *ngIf="!editLocked && !editActive">{{ time }}</div>

  <div
    *ngIf="fpsSet && editActive"
    class="editable-time-with-fps edit-border"
    (dblclick)="
      finishTimeEdit(hours.value, minutes.value, seconds.value, fps.value)
    "
  >
    <div class="inputs-container">
      <input
        #hours
        class="input-field input-width"
        type="number"
        value="{{ hoursValue }}"
        max="99"
        min="0"
        (change)="prependZero($event)"
      />:
      <input
        #minutes
        class="input-field input-width"
        type="number"
        value="{{ minutesValue }}"
        max="59"
        min="0"
        (change)="prependZero($event)"
      />:
      <input
        #seconds
        class="input-field input-width"
        type="number"
        value="{{ secondsValue }}"
        max="59"
        min="0"
        (change)="prependZero($event)"
      />.
      <input
        #fps
        class="input-field input-width"
        type="number"
        value="{{ fpsValue }}"
        max="99"
        min="0"
        (change)="prependZero($event)"
      />
    </div>
  </div>

  <div
    *ngIf="!fpsSet && editActive"
    class="editable-time-with-fps edit-border"
    (dblclick)="
      finishTimeEdit(hours.value, minutes.value, seconds.value, ms.value)
    "
  >
    <div class="inputs-container">
      <input
        #hours
        class="input-field input-width"
        type="number"
        value="{{ hoursValue }}"
        max="99"
        min="0"
        (change)="prependZero($event)"
      />:
      <input
        #minutes
        class="input-field input-width"
        type="number"
        value="{{ minutesValue }}"
        max="59"
        min="0"
        (change)="prependZero($event)"
      />:
      <input
        #seconds
        class="input-field input-width"
        type="number"
        value="{{ secondsValue }}"
        max="59"
        min="0"
        (change)="prependZero($event)"
      />.
      <input
        #ms
        class="input-field ms-input-width"
        type="number"
        value="{{ msValue }}"
        max="999"
        min="0"
        (change)="prependZerosMilliseconds($event)"
      />
    </div>
  </div>
</div>
